<div class="form-group lead">
  <label class="form-title" (click)="goster()"
    >{{ inputLabel | translate | async }}
  </label>
  <span class="form-input-wrapper" *ngIf="textMask">
    <input
      class="form-control"
      type="{{ inputType }}"
      name="{{ inputLabel }}"
      [formControl]="formControl"
      [disabled]="formControl?.disabled"
      [ngClass]="{
        'is-invalid':
          this.formService.hasError(this.isShowError, this.formControl) &&
          isShowError,
        'is-valid':
          !this.formService.hasError(this.isShowError, this.formControl) &&
          isShowError
      }"
      [textMask]="{ mask: textMask }"
    />
    <div class="bar"></div>
    <div class="hint" *ngIf="hint">
      <i>{{ hint }}</i>
    </div>
  </span>

  <span class="form-input-wrapper" *ngIf="!textMask">
    <input
      class="form-control"
      type="{{ inputType }}"
      name="{{ inputLabel }}"
      [formControl]="formControl"
      [disabled]="formControl?.disabled"
      [ngClass]="{
        'is-invalid':
          this.formService.hasError(this.isShowError, this.formControl) &&
          isShowError,
        'is-valid':
          !this.formService.hasError(this.isShowError, this.formControl) &&
          isShowError
      }"
    />
    <div class="bar"></div>
    <div class="hint" *ngIf="hint">
      <i>{{ hint }}</i>
    </div>
  </span>

  <ol
    class="error-message-group"
    *ngIf="this.formService.hasError(this.isShowError, this.formControl)"
  >
    <li
      class="error-message"
      *ngFor="
        let error of this.formService.getFormValidationErrors(this.formControl)
      "
    >
      {{ error }}
    </li>
  </ol>
</div>
